import React from 'react';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import '../profile.scss';
import { IND, ENP, Resources, claim, SUCCESS, ORG } from 'app/config/constants';
import { connect } from 'react-redux';
import { IRootState } from 'app/shared/reducers';
import { translate } from 'react-jhipster';
import { getFile, verifyFile, uploadFileDVC, appovalCreate } from 'app/modules/account/user/user.reducer';
import ModalListFile from 'app/modules/account/user/identity-info/modal-list-file';
import AlertMessage from 'app/view-common/AlertMessage';
import value from '*.json';

export interface IModalResourcesProps extends StateProps, DispatchProps {
  display: boolean;
  closeModal: Function;
  userProfile: any;
  updateAttribute: Function;
  type: string;
  uploadFile: Function;
}

export interface IModalResourcesState {
  src: string;
  fileInValid: boolean;
  selectedFile: any;
  isDisplayModalSelectFile: boolean;
  displayModalListFile: boolean;
  listfileDVC: any;
  selectDVC: any;
  typeUpload: string;
  showMessageError: boolean;
  messageError: string;
  value: any;
  isLoginByIdentity: boolean;
}

var conditions = ['.pdf'];

class ModalResources extends React.Component<IModalResourcesProps, IModalResourcesState> {
  state: IModalResourcesState = {
    src: '',
    fileInValid: false,
    selectedFile: null,
    isDisplayModalSelectFile: false,
    displayModalListFile: false,
    listfileDVC: null,
    selectDVC: null,
    typeUpload: '',
    showMessageError: false,
    messageError: '',
    value: null,
    isLoginByIdentity: false
  };

  componentDidMount() {
    // this.props.getFile();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.userProfile !== nextProps.userProfile) {
      this.checkExistsIdentity(nextProps.userProfile);
    }

    if (this.props.resUpdateAttr !== nextProps.resUpdateAttr) {
      this.setState({
        src: ''
      });
    }
    if (this.props.listFile != nextProps.listFile) {
      this.setState({ listfileDVC: nextProps.listFile.data.BaseResponse });
    }

    if (this.props.verifyfile != nextProps.verifyfile) {
      if (nextProps.verifyfile.status == 'SUCCESS') {
        this.closeModal();
        this.props.uploadFile(this.state.value, this.state.selectedFile, this.state.typeUpload);
      } else {
        this.setState({
          src: Resources[5].key,
          showMessageError: true,
          messageError: 'Tệp đính kèm không phải tệp chứng thực điện tử bởi cơ quan tư pháp !'
        });
      }
    }
    if (this.props.uploadfileDVC !== nextProps.uploadfileDVC) {
      if (nextProps.uploadfileDVC.status == 'NOT_FOUND') {
        this.setState({
          src: Resources[5].key,
          showMessageError: true,
          messageError: 'Lỗi trong quá trình xác thực file !'
        });
      }
      if (nextProps.uploadfileDVC.status == 'SUCCESS') {
        var valueAppro = this.state.value;
        valueAppro.umFileId = nextProps.uploadfileDVC.fileId;
        valueAppro.active = 0;
        this.props.appovalCreate(valueAppro);
        this.closeModal();
      } else if (nextProps.uploadfileDVC.status == 'ERROR') {
        this.setState({
          src: Resources[5].key,
          showMessageError: true,
          messageError: 'Tệp đính kèm không phải tệp chứng thực điện tử bởi cơ quan tư pháp !'
        });
      }
    }
  }

  handleValidSubmit = (event, values) => {
    switch (this.props.userProfile.userType) {
      case IND:
        if (this.state.src == Resources[5].key) {
          if (this.state.selectedFile == null) {
            this.setState({
              showMessageError: true,
              messageError: 'bạn chưa chọn file !'
            });
          } else {
            this.setState({ value: values });
            if (this.state.typeUpload == 'DVC') {
              this.props.uploadFileDVC(this.state.selectedFile);
            } else {
              this.props.verifyFile(this.state.selectedFile);
            }
          }
        } else {
          this.props.updateAttribute(
            this.state.src == '' ? (this.props.type == claim.IDENTITY ? Resources[2].key : Resources[0].key) : this.state.src,
            values
          );
        }
        break;
      case ENP:
        this.props.updateAttribute(Resources[3].key, values);
        break;
      case ORG:
        this.props.updateAttribute(Resources[4].key, values);
        break;
      default:
        break;
    }
    this.closeModalListFile();
  };
  handleChange = event => {
    this.setState({
      src: event.target.value
    });
  };
  closeModal = () => {
    this.setState({
      src: '',
      selectedFile: null
    });
    this.props.closeModal();
  };
  selectFileUpload = (event, type) => {
    if (type == 'COM') {
      var nameFile = event.target.files[0].name;
      var checkFileUpload = conditions.some(e =>
        nameFile
          .substr(nameFile.length <= 5 ? nameFile.length - 4 : nameFile.length - 6)
          .toLowerCase()
          .includes(e)
      );
      if (!checkFileUpload || event.target.files[0].size > 25000000) {
        this.setState({
          fileInValid: true
        });
      } else {
        this.setState({
          fileInValid: false,
          selectedFile: event.target.files[0],
          typeUpload: 'COM'
        });
      }
    } else {
      const file = { fileUrl: '', fileName: '' };
      file.fileUrl = event.URL;
      file.fileName = event.TENTEP;
      this.setState({
        selectedFile: file,
        typeUpload: 'DVC',
        fileInValid: false
      });
    }
  };
  closeModalListFile = () => {
    this.setState({
      displayModalListFile: false
    });
  };
  openModalListFile = () => {
    this.setState({
      displayModalListFile: true
    });
  };
  closeAlert = () => {
    this.setState({
      showMessageError: false
    });
  };

  // check when update with tax
  checkExistsIdentity = user => {
    let identity = '';
    if (user && user.attributes) {
      let arrIdentity = user.attributes.filter(item => item.name == 'identity');
      identity = arrIdentity.length > 0 ? arrIdentity[0].value : '';
    }
    if (identity) {
      this.setState({ isLoginByIdentity: true });
    } else {
      this.setState({ isLoginByIdentity: false });
    }
  };

  render() {
    return (
      <div>
        <AlertMessage showModal={this.state.showMessageError} message={this.state.messageError} closeAlert={this.closeAlert} />
        {/* <ModalListFile
          display={this.state.displayModalListFile}
          closeModal={this.closeModalListFile}
          OpenModal={this.openModalListFile}
          listFile={this.state.listfileDVC}
          selectFile={this.selectFileUpload}
        /> */}
        <Modal
          isOpen={this.props.display}
          centered={window.location === window.parent.location}
          size="lg"
          backdrop="static"
          style={{ maxWidth: window.innerWidth < 768 ? '100%' : '80%' }}
        >
          <ModalHeader style={{ borderBottom: 'none' }} toggle={this.closeModal} />
          <ModalBody>
            <AvForm onValidSubmit={this.handleValidSubmit}>
              <div className="row" style={{ margin: '0px auto' }}>
                <div className={window.innerWidth < 768 ? 'col-12' : 'col-sm-3'}>
                  <label style={{ marginRight: '30px' }}>Chọn nguồn xác minh</label>
                </div>
                <div className={window.innerWidth < 768 ? 'col-12' : 'col-sm-9'}>
                  {this.props.userProfile.userType == IND ? (
                    this.props.type == claim.IDENTITY ? (
                      <AvField name="resources" label="" type="select" onChange={this.handleChange}>
                        <option key={Resources[2].key} value={Resources[2].key}>
                          {Resources[2].value}
                        </option>
                        <option key={Resources[5].key} value={Resources[5].key}>
                          {Resources[5].value}
                        </option>
                      </AvField>
                    ) : (
                      <AvField name="resources" label="" type="select" onChange={this.handleChange}>
                        <option key={Resources[0].key} value={Resources[0].key}>
                          {Resources[0].value}
                        </option>
                        <option key={Resources[1].key} value={Resources[1].key}>
                          {Resources[1].value}
                        </option>
                      </AvField>
                    )
                  ) : this.props.userProfile.userType == ENP ? (
                    <AvField name="resources" label="" type="select">
                      <option key={Resources[3].key} value={Resources[3].key}>
                        {Resources[3].value}
                      </option>
                    </AvField>
                  ) : (
                    <AvField name="resources" label="" type="select">
                      <option key={Resources[4].key} value={Resources[4].key}>
                        {Resources[4].value}
                      </option>
                    </AvField>
                  )}
                </div>

                {/* CSDL thuế*/}
                {this.props.type == claim.IDENTITY && (this.state.src == Resources[2].key || this.state.src == '') ? (
                  <div className={window.innerWidth < 768 ? 'col-12' : 'col-sm-3'}>
                    <label className="requiredLabel" style={{ marginRight: '30px' }}>
                      Mã số thuế
                    </label>
                  </div>
                ) : null}
                {this.props.type == claim.IDENTITY && (this.state.src == Resources[2].key || this.state.src == '') ? (
                  <div className={window.innerWidth < 768 ? 'col-12' : 'col-sm-9'}>
                    {this.props.userProfile.userType == IND && (this.state.src == Resources[2].key || this.state.src == '') ? (
                      <AvField
                        name="tax"
                        placeholder="Nhập mã số thuế"
                        type="text"
                        validate={{
                          required: { value: true, errorMessage: 'Bạn phải nhập mã số thuế.' },
                          pattern: {
                            value: '^([0-9]{10})+$',
                            errorMessage: 'Mã số thuế phải có 10 ký tự số'
                          },
                          maxLength: { value: 10, errorMessage: 'Mã số thuế phải có 10 ký tự' }
                        }}
                      />
                    ) : null}
                  </div>
                ) : null}

                {/*CMT/CCCDn*/}
                {this.props.type == claim.IDENTITY &&
                (this.state.src == Resources[5].key || this.state.src == Resources[2].key || this.state.src == '') ? (
                  <div className={window.innerWidth < 768 ? 'col-12' : 'col-sm-3'}>
                    <label className="requiredLabel">{this.state.isLoginByIdentity ? 'Số CCCD' : 'Số CMT'}</label>
                  </div>
                ) : null}
                {this.props.type == claim.IDENTITY &&
                (this.state.src == Resources[5].key || this.state.src == Resources[2].key || this.state.src == '') ? (
                  <div className={window.innerWidth < 768 ? 'col-12' : 'col-sm-9'}>
                    {this.props.userProfile.userType == IND ? (
                      <AvField
                        name="identity"
                        placeholder={this.state.isLoginByIdentity ? 'Nhập CCCD' : ' Nhập CMT'}
                        type="text"
                        validate={{
                          required: {
                            value: true,
                            errorMessage: this.state.isLoginByIdentity ? 'Bạn phải nhập số cccd' : 'Bạn phải nhập số cmt'
                          },
                          pattern: {
                            value: this.state.isLoginByIdentity ? '^([0-9]{12})+$' : '^([0-9]{9})+$',
                            errorMessage: this.state.isLoginByIdentity ? 'Số cccd yêu cầu 12 kí tự số' : 'Số cmt yêu cầu 9 kí tự số'
                          },
                          minLength: {
                            value: this.state.isLoginByIdentity ? 12 : 9,
                            errorMessage: this.state.isLoginByIdentity ? 'Số cccd phải có 12 kí tự.' : 'Số cmt phải có 9 kí tự.'
                          },
                          maxLength: {
                            value: this.state.isLoginByIdentity ? 12 : 9,
                            errorMessage: this.state.isLoginByIdentity ? 'Số cccd phải có 12 kí tự.' : 'Số cmt phải có 9 kí tự.'
                          }
                        }}
                      />
                    ) : null}
                  </div>
                ) : null}
                {/*tệp đính kèm chứng thư điện tử*/}
                {this.state.src == Resources[5].key ? <div className={window.innerWidth < 768 ? 'col-12' : 'col-sm-3'} /> : null}
                {this.state.src == Resources[5].key ? (
                  <div className={window.innerWidth < 768 ? 'col-12' : 'col-sm-9'}>
                    {this.props.userProfile.userType == IND ? (
                      <div className="row">
                        <label className="requiredLabel">
                          Tệp đính kèm (Giấy xác nhận số CMND có dấu đỏ của cơ quan công an và được cơ quan tư pháp chứng thực ký số) được
                          tải từ thiết bị hoặc tải từ thư mục "Giấy tờ cá nhân"
                        </label>
                      </div>
                    ) : null}
                  </div>
                ) : null}

                {this.state.src == Resources[5].key ? <div className={window.innerWidth < 768 ? 'col-12' : 'col-sm-3'} /> : null}
                {this.state.src == Resources[5].key ? (
                  <div className={window.innerWidth < 768 ? 'col-12' : 'col-sm-9'}>
                    {this.props.userProfile.userType == IND ? (
                      <div className="row">
                        <div className="col-sm-6 upload-btn-wrapper-profile" style={{}}>
                          <button
                            className={
                              this.state.selectedFile && this.state.typeUpload == 'COM'
                                ? 'btn-upload-profile required'
                                : 'btn-upload-profile'
                            }
                          >
                            <label> Chọn tệp từ máy tính</label>
                          </button>
                          <AvField
                            style={{ height: '80px' }}
                            name="fileUrl"
                            label=""
                            type="file"
                            // validate={{
                            //   required: {
                            //     value: this.props.isEdit
                            //       ? this.props.infoDetail['fileUrl'] == null && this.state.selectedFile == null
                            //         ? true
                            //         : false
                            //       : true,
                            //     errorMessage: 'Bạn phải chọn file.'
                            //   }
                            // }}
                            value=""
                            onChange={() => this.selectFileUpload(event, 'COM')}
                          />
                          <label style={{ fontSize: '18px', fontWeight: 'bold', textAlign: 'left' }}>(Chỉ nhận file pdf.)</label>
                          <label style={{ fontSize: '18px', color: 'red', marginLeft: '5px' }}>
                            {this.state.fileInValid ? 'File không hợp lệ.' : ''}
                            {this.state.selectedFile
                              ? this.state.selectedFile.size > 25000000
                                ? 'file không được lớn hơn 25mb '
                                : ''
                              : ''}
                          </label>
                          <br />

                          {this.state.selectedFile != null ? (
                            <div style={{ textAlign: 'center' }}>
                              <img style={{ height: '90px', width: '80px' }} src={require('../../../../images/PDF_file_icon.svg')} alt="" />
                              <br />
                              <label style={{ textAlign: 'center', wordBreak: 'break-word' }}>
                                {this.state.typeUpload == 'COM' ? this.state.selectedFile.name : null}
                              </label>
                              <label style={{ textAlign: 'center', wordBreak: 'break-word' }}>
                                {this.state.typeUpload == 'DVC' ? this.state.selectedFile.fileName : null}
                              </label>
                            </div>
                          ) : null}
                        </div>

                        <div className="col-sm-6 upload-btn-wrapper-profile" style={{ textAlign: 'center' }}>
                          {/*<button className={this.state.selectedFile2 ? "btn-upload required" : "btn-upload"}>Chọn tệp từ thư mục giấy tờ cá nhân</button>*/}
                          <button
                            className={
                              this.state.selectedFile && this.state.typeUpload == 'DVC'
                                ? 'btn-upload-profile required'
                                : 'btn-upload-profile'
                            }
                            type="button"
                            onClick={() => this.openModalListFile()}
                          >
                            <label>Chọn tệp từ thư mục giấy tờ cá nhân</label>
                          </button>
                        </div>
                      </div>
                    ) : null}
                  </div>
                ) : null}
                {/*end*/}
              </div>
              {this.props.userProfile.userType == IND && this.state.src == Resources[1].key ? (
                <div className="row" style={{ margin: '0px auto' }}>
                  <div className={window.innerWidth < 768 ? 'col-12' : 'col-sm-3'}>
                    <label style={{ marginRight: '30px' }}>{translate('global.form.insurance.label')}</label>
                  </div>
                  <div className={window.innerWidth < 768 ? 'col-12' : 'col-sm-9'}>
                    <AvField
                      name="sic"
                      label=""
                      value={this.props.userProfile.sic ? this.props.userProfile.sic : null}
                      placeholder={translate('global.form.insurance.placeholder')}
                      validate={{
                        required: { value: true, errorMessage: translate('global.messages.validate.insurance.required') },
                        maxLength: { value: 10, errorMessage: translate('global.messages.validate.insurance.maxlength') },
                        pattern: {
                          value: '^([0-9]{10})+$',
                          errorMessage: 'Mã bảo hiểm yêu cầu 10 ký tự số.'
                        }
                      }}
                    />
                  </div>
                </div>
              ) : null}
              <div className="row justify-content-center" style={{ marginTop: '20px' }}>
                <div className={window.innerWidth < 768 ? 'col-6' : 'col-sm-3'}>
                  <Button className="btn-register-white" style={{ marginLeft: 'auto' }} onClick={this.closeModal} block>
                    Bỏ qua
                  </Button>
                </div>
                <div className={window.innerWidth < 768 ? 'col-6' : 'col-sm-3'}>
                  <Button className="btn-register" type="submit" block>
                    {this.state.src == Resources[5].key ? 'Gửi duyệt' : 'Cập nhật'}
                  </Button>
                </div>
              </div>
            </AvForm>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  resUpdateAttr: storeState.userInfo.resUpdateAttr,
  listFile: storeState.userInfo.listFile,
  verifyfile: storeState.userInfo.verify,
  uploadfileDVC: storeState.userInfo.uploadfileDVC,
  userProfile: storeState.userInfo.userProfile
});
const mapDispatchToProps = { getFile, verifyFile, uploadFileDVC, appovalCreate };
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalResources);
